const CLOSE_PHOTO_LIST = 'CLOSE_PHOTO_LIST';
const OPEN_PHOTO_LIST = 'OPEN_PHOTO_LIST';


const initState = {
    show: false,
    photo: false,
    list: []
}

export default function memberPhoto(state = initState, action) {
    if (action.type === OPEN_PHOTO_LIST) {
        return {
            show: true,
            photo: action.photo,
            list: action.list
        }
    }

    if (action.type === CLOSE_PHOTO_LIST) {
        return initState
    }

    return state;
}

export function openPhoto(photo, list = null) {
    return {
        type: OPEN_PHOTO_LIST,
        photo,
        list
    }

}

export function closePhotoList() {
    return {
        type: CLOSE_PHOTO_LIST
    }
}


// WEBPACK FOOTER //
// ./src/reducers/photoList.js